import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CardWordList } from '../../../asset/utils/CardWordList';
import { ContentBookPath, ContentPath } from '../../../asset/utils/Constant';
import { setCardUnit } from '../../../store/CardSlice';
import { setPopCard, setPopVideo } from '../../../store/CommonSlice';
import { setVideoSrc } from '../../../store/VideoSlice';
import { Audio } from '../../_atoms/Audio';
import { Button } from '../../_atoms/Button';
import { Image } from '../../_atoms/Image';

export const Book = (props) => {
  const state = useSelector((state) => state);
  const dispatch = useDispatch();

  const [src, setSrc] = useState('');
  const [answer, setAnswer] = useState([]);
  const [track, setTrack] = useState([]);
  const [card, setCard] = useState([]);
  const [chant, setChant] = useState([]);
  const [video, setVideo] = useState([]);

  useEffect(() => {
    if ((state.book.bookInfo)[state.book.current_page]) {
      setSrc((state.book.bookInfo)[state.book.current_page].path);
  
      const answerArray = (state.book.bookInfo)[state.book.current_page].answer && (state.book.bookInfo)[state.book.current_page].answer.map(ans => ({
        ...ans, act : false
      }));
      setAnswer(answerArray);
  
      const trackArray = (state.book.bookInfo)[state.book.current_page].track && (state.book.bookInfo)[state.book.current_page].track.map(tra => ({
        ...tra, act : false
      }));
      setTrack(trackArray);

      setCard((state.book.bookInfo)[state.book.current_page].card);

      const chantArray = (state.book.bookInfo)[state.book.current_page].chant && (state.book.bookInfo)[state.book.current_page].chant.map(cha => ({
        ...cha, act : false
      }));
      setChant(chantArray);

      setVideo((state.book.bookInfo)[state.book.current_page].video);
    }

    if (state.common.pop_audio || state.common.pop_video || state.common.pop_card) {
      const answerArray = (state.book.bookInfo)[state.book.current_page].answer && (state.book.bookInfo)[state.book.current_page].answer.map(ans => ({
        ...ans, act : false
      }));
      setAnswer(answerArray);
  
      const trackArray = (state.book.bookInfo)[state.book.current_page].track && (state.book.bookInfo)[state.book.current_page].track.map(tra => ({
        ...tra, act : false
      }));
      setTrack(trackArray);

      setCard((state.book.bookInfo)[state.book.current_page].card);

      const chantArray = (state.book.bookInfo)[state.book.current_page].chant && (state.book.bookInfo)[state.book.current_page].chant.map(cha => ({
        ...cha, act : false
      }));
      setChant(chantArray);
    }
  }, [state.book.current_menu, state.book.current_content, state.book.current_unit, state.book.current_page, state.book.bookInfo, state.common.pop_video, state.common.pop_audio, state.common.pop_card]);

  const onAnswer = (idx) => {
    answer[idx].act = !answer[idx].act;
    setAnswer([...answer]);
  };

  const onTrack = (idx) => {
    const index = track.findIndex((tra) => tra.act === true);
    if (index !== -1 && index !== idx) {
      track[index].act = false;
      setTrack([...track]);
    }

    const chantArray = (state.book.bookInfo)[state.book.current_page].chant && (state.book.bookInfo)[state.book.current_page].chant.map(cha => ({
      ...cha, act : false
    }));
    setChant(chantArray);
    
    track[idx].act = !track[idx].act;
    setTrack([...track]);
  };

  const onChant = (idx) => {
    const trackArray = (state.book.bookInfo)[state.book.current_page].track && (state.book.bookInfo)[state.book.current_page].track.map(tra => ({
      ...tra, act : false
    }));
    setTrack(trackArray);

    const index = chant.findIndex((cha) => cha.act === true);
    if (index !== -1 && index !== idx) {
      chant[index].act = false;
      setChant([...chant]);
    }
    
    chant[idx].act = !chant[idx].act;
    setChant([...chant]);
  };
  
  const onVideo = (idx) => {
    const trackArray = (state.book.bookInfo)[state.book.current_page].track && (state.book.bookInfo)[state.book.current_page].track.map(tra => ({
      ...tra, act : false
    }));
    setTrack(trackArray);

    const chantArray = (state.book.bookInfo)[state.book.current_page].chant && (state.book.bookInfo)[state.book.current_page].chant.map(cha => ({
      ...cha, act : false
    }));
    setChant(chantArray);

    dispatch(setVideoSrc(video[idx].path));
    dispatch(setPopVideo(!state.common.pop_video));
  };

  const onCard = (idx) => {
    const trackArray = (state.book.bookInfo)[state.book.current_page].track && (state.book.bookInfo)[state.book.current_page].track.map(tra => ({
      ...tra, act : false
    }));
    setTrack(trackArray);

    const chantArray = (state.book.bookInfo)[state.book.current_page].chant && (state.book.bookInfo)[state.book.current_page].chant.map(cha => ({
      ...cha, act : false
    }));
    setChant(chantArray);

    dispatch(setPopCard(!state.common.pop_card));

    dispatch(setCardUnit(CardWordList[state.book.current_book].findIndex((car) => car.name === 'Unit ' + card[idx].path)));
  };

  return (
    <>
      <Image
        src={ContentBookPath + (state.book.current_book + 1) + '/' + src + '.png'}
        alt={src}
        type='ebook'
        />

        {/* answer */}
        {answer && (answer.map((ans, idx) => {
          return (
            <>
              <Button 
                type="book" 
                value='answer'
                bottom={(ans.posY - 19)  + 'px'} 
                left={(ans.posX - 21) + 'px'}
                onClick={() => onAnswer(idx)}
              />
              <Image
                src={ContentBookPath + (state.book.current_book + 1) + '/' + ans.path + '.png'}
                alt={ans.path}
                act={answer[idx].act}
                type='book'
              />
            </>
          )
        }))}

        {/* track */}
        {track && (track.map((tra, idx) => {
          return (
            <>
              <Button 
                type="book" 
                value='track' 
                bottom={(tra.posY - 19)  + 'px'} 
                left={(tra.posX - 21) + 'px'}
                onClick={() => onTrack(idx)}
              />
              {track[idx].act && (
                <Audio
                  src={ContentPath + tra.path + '.mp3'}
                  act={track[idx].act}
                  autoplay={true}
                  bottom={(tra.posY - 19 + 64)  + 'px'} 
                  left={(tra.posX - 21 + 45 * 0.5) + 'px'}
                />
              )}
            </>
          )
        }))}
        
        {/* card */}
        {card && (card.map((car, idx) => {
          return (
            <>
              <Button 
                type="book" 
                value='card' 
                bottom={(car.posY - 19)  + 'px'} 
                left={(car.posX - 21) + 'px'}
                onClick={() => onCard(idx)}
              />
            </>
          );
        }))}

        {/* chant */}
        {chant && (chant.map((cha, idx) => {
          return (
            <>
              <Button 
                type="book" 
                value='chant' 
                bottom={(cha.posY - 19)  + 'px'} 
                left={(cha.posX - 21) + 'px'}
                onClick={() => onChant(idx)}
              />
              {chant[idx].act && (
                <Audio
                  src={ContentPath + cha.path + '.mp3'}
                  act={chant[idx].act}
                  autoplay={true}
                  bottom={(cha.posY - 19 + 64)  + 'px'} 
                  left={(cha.posX - 21 + 45 * 0.5) + 'px'}
                />
              )}
            </>
          )
        }))}
        
        {/* video */}
        {video && (video.map((vid, idx) => {
          return (
            <>
              <Button 
                type="book" 
                value='video' 
                bottom={(vid.posY - 19) + 'px'} 
                left={(vid.posX - 21) + 'px'}
                onClick={() => onVideo(idx)}
              />
            </>
          );
        }))}
    </>
  );
};